import { Button, Card, Col, Row, Tag } from "antd";
import React from "react";
import {
  convertMsToHoursMinutes,
  formatDate,
  formatDateWithDay,
  isNull,
  toReadableTime,
} from "../../../../shared/helpers";
import { TimesheetActionButtonCol } from "../TimesheetActionButtonCol/TimesheetActionButtonCol";
import { TIME_SHEET_PENDING_ACTION } from "../../TimeSheetConstants";

const TimesheetListCard = ({
  data,
  handleApproveRejectClick,
  handleOpenTimeModal,
}) => {
  const { date } = data;
  const {
    shiftType = null,
    clockIn,
    clockOut,
    totalWorkedMs,
    overtimeReadable,
    status,
  } = data?.entry;
  const isDisable = isNull(clockOut?.raw);
  const isPending = status == TIME_SHEET_PENDING_ACTION;
  return (
    <Card>
      <Row>
        <Col span={24}>
          <Row className='mb-7'>
            <Col span={24}>
              <Tag color="default">{shiftType?.toUpperCase()}</Tag>
            </Col>
          </Row>
          <Row className='mb-7' >
            <Col span={13} className="left-col-timesheetList">
              Date
            </Col>
            <Col span={11}>{formatDateWithDay(date)}</Col>
          </Row>

          <Row
          className='mb-7'
            style={{ cursor: isPending ? "pointer" : "not-allowed" }}
            onClick={() =>
              isPending ? handleOpenTimeModal(data?.entry) : null
            }
          >
            <Col span={13} className="left-col-timesheetList">
              Clock-in -- Check Out
            </Col>
            <Col span={11}>
              {toReadableTime(clockIn?.raw)} -- {toReadableTime(clockOut?.raw)}
            </Col>
          </Row>
          <Row className='mb-7'>
            <Col span={13} className="left-col-timesheetList">
              Work Hrs
            </Col>
            <Col span={11}>{convertMsToHoursMinutes(totalWorkedMs)}</Col>
          </Row>
          <Row className='mb-7'>
            <Col span={13} className="left-col-timesheetList">
              Overtime
            </Col>
            <Col span={11}>{overtimeReadable || "N/A"}</Col>
          </Row>
          <TimesheetActionButtonCol
            disable={isDisable}
            status={status}
            handleApprove={() => handleApproveRejectClick(data?.entry)}
            handleReject={() => handleApproveRejectClick(data?.entry)}
          />
        </Col>
      </Row>
    </Card>
  );
};

export { TimesheetListCard };
